module.exports = __webpack_public_path__ + "static/media/douglas.d2655dd1.jpg";